import { Button, FlexContainer, palette } from '@busie/ui-kit'
import React from 'react'

interface Props {
  onClick: () => void
}

const ShowMore: React.FC<React.PropsWithChildren<Props>> = ({ onClick }) => {
  return (
    <FlexContainer px={2} fullWidth>
      <Button
        typestyle="secondary"
        fullWidth
        sx={{
          border: `1px solid ${palette.black.plus70}`,
          color: palette.black.plus10,
          fontSize: '14px',
          fontWeight: 500,
        }}
        onClick={onClick}
      >
        Show more information
      </Button>
    </FlexContainer>
  )
}

export default ShowMore
